import { StatusData } from "store/Slices/Status/statusSlice";
import { RootState } from "store/store";

const selectStatusPlan = (state: RootState) => state.statusSlice.statusPlan;


export const selectGetElementStatus = (gridElementId: string) => {
  const emptyStatusData: StatusData = {
        id: gridElementId,
        status: "",
        isOccupied: false,
        hasStacks: false,
        hasInventory: false,
        hasPallet: false,
        hasCage: false,
        isOperationInProgress: false,
        reservationType: "",
        operationType: "",
        aConfirmer: false,
        verifierLe: ""
      };
  const selector = (state: RootState): StatusData => {
    const data = selectStatusPlan(state).find(s => s.id === gridElementId);
    if (!data)
      return emptyStatusData;
    return data;
  };
  (selector as any)._fromSelector = "getElementStatusSelector";
  return selector;
};
/*
export const selectHasStacks = (gridElementId: string) => {
  const selector = (state: RootState): boolean => {
    const data = selectStatusPlan(state).find(s => s.id === gridElementId);

    if (!data) return false;
    return data?.hasStacks;
  };
  (selector as any)._fromSelector = "hasStacksSelector";
  return selector;
};

export const selectHasPallet = (gridElementId: string) => {
  const selector = (state: RootState): boolean => {
    const data = selectStatusPlan(state).find(s => s.id === gridElementId);

    if (!data) return false;
    return data?.hasPallet;
  };
  (selector as any)._fromSelector = "hasPalletSelector";
  return selector;
};

export const selectHasCage = (gridElementId: string) => {
  const selector = (state: RootState): boolean => {
    const data = selectStatusPlan(state).find(s => s.id === gridElementId);

    if (!data) return false;
    return data?.hasCage;
  };
  (selector as any)._fromSelector = "hasCageSelector";
  return selector;
};

export const selectHasInventory = (gridElementId: string) => {
  const selector = (state: RootState): boolean => {
    const data = selectStatusPlan(state).find(s => s.id === gridElementId);

    if (!data) return false;
    return data?.hasInventory;
  };
  (selector as any)._fromSelector = "hasInventorySelector";
  return selector;
};
*/